<template>
    <div class="funItem">
        <div class="itemTitle">{{ title }}</div>
        <div :style="{ backgroundImage: `url('${backgroundImage}')`, }" class="maxBnner">
            <img :src="list[currentIndex].big_cover" alt="" />
        </div>
        <div class="scorllBanner">
            <div class="headBox">
                <div class="headLeft">
                    <div @click="currentIndex = index" :class="index == currentIndex ? 'activeLine' : ''"
                        v-for="(item, index) in list" :key="item.id" class="line">
                    </div>
                </div>
                <div class="rightBtn">
                    <div v-show="currentIndex <= 0" @click="currenChange(-1)" class="bannerBtn">
                        <img src="@/assets/index/bannerBtn.png" alt="" />
                    </div>
                    <div v-show="currentIndex > 0" @click="currenChange(-1)" class="bannerBtn bannerBtnRight">
                        <img src="@/assets/index/rightBtn.png" alt="" />
                    </div>

                    <div v-show="currentIndex < list.length - 1" @click="currenChange(1)" class="bannerBtn">
                        <img src="@/assets/index/rightBtn.png" alt="" />
                    </div>
                    <div v-show="currentIndex >= list.length - 1" @click="currenChange(1)"
                        class="bannerBtn bannerBtnRight">
                        <img src="@/assets/index/bannerBtn.png" alt="" />
                    </div>
                </div>
            </div>
            <div :style="{ width: `${scorllBannerWidth}px`, transform: `translate(${scorllBannerLeft}px , 0)` }"
                class="bannerBox">
                <div :style="{ transform: `translate(${bannerTranslateX} , 0)`, }" class="bannerList">
                    <div v-for="item in list" :key="item.id" class="bannerItem">
                        <img :src="item.cover" alt="" />
                        <div class="bannerName">{{ item.title }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentIndex: 0,
            scorllBannerWidth: 1540,
            scorllBannerLeft: 360,
            maxWidth: 1200,
            scx: 605,
        }
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        backgroundImage: {
            type: String,
            default: '',
        },
        list: {
            type: Array,
            default: (() => [])
        }
    },
    computed: {
        bannerTranslateX() {
            return `-${this.currentIndex * (585 + 30)}px`
        },
    },
    created() {
        let maxWidth = window.innerWidth
        if (maxWidth > 1200) {
            let scorllBannerLeft = (maxWidth - 1200) / 2
            this.scorllBannerLeft = scorllBannerLeft
            this.scorllBannerWidth = maxWidth - scorllBannerLeft - 20
            this.scx = 605
        } else {
            let scorllBannerLeft = 0
            this.scorllBannerLeft = scorllBannerLeft
            this.scorllBannerWidth = maxWidth
            this.scx = 0.6 * maxWidth + 10
        }

    },
    methods: {
        currenChange(num) {
            if (num == 1 && this.currentIndex >= this.list.length - 1) {
                this.currentIndex = this.list.length - 1
                return
            }
            if (num == -1 && this.currentIndex <= 0) {
                this.currentIndex = 0
                return
            }
            this.currentIndex += num
        },
    },
}
</script>

<style lang="scss" scoped>
.funItem {
    margin-top: 0px;
    margin-bottom: 116px;

    .itemTitle {
        font-weight: 500;
        font-size: 40px;
        color: #000000;
        width: 1200px;
        margin: auto;

    }

    .maxBnner {
        width: 100%;
        height: 700px;
        margin-top: 40px;
        background-size: 100% 100%;

        img {
            width: 1200px;
            height: 700px;
            object-fit: cover;
            display: block;
            margin: auto;
        }
    }

    .scorllBanner {
        margin-top: 40px;

        .headBox {
            display: flex;
            justify-content: space-between;
            width: 1200px;
            margin: auto;

            .headLeft {
                display: flex;
                align-items: center;

                .line {
                    width: 36px;
                    height: 2px;
                    background: #B2B2B2;
                    border-radius: 1px;
                    margin-right: 10px;
                    cursor: pointer;
                }

                .activeLine {
                    background: #000000;
                }
            }

            .rightBtn {
                display: flex;

                .bannerBtn {
                    width: 40px;
                    height: 40px;
                    margin-left: 10px;
                    cursor: pointer;

                    img {
                        width: 40px;
                        height: 40px;
                        display: block;
                    }
                }

                .bannerBtnRight {
                    transform: rotate(180deg);
                }
            }
        }

        .bannerBox {
            overflow: hidden;
            margin-top: 30px;

            .bannerList {
                display: flex;
                flex-wrap: nowrap;
                transition: all 0.3s;

                .bannerItem {
                    margin-right: 30px;
                    width: 585px;

                    img {
                        width: 585px;
                        height: 600px;
                        display: block;
                        object-fit: cover;
                    }

                    .bannerName {
                        font-weight: 500;
                        font-size: 21px;
                        color: #000000;
                        line-height: 28px;
                        margin-top: 40px;
                    }
                }
            }
        }
    }
}

@media screen and (max-width:1200px) {

    .funItem {
        margin-top: 20px;

        .itemTitle {
            font-weight: 500;
            font-size: 18px;
            color: #000000;
            width: 100%;
            margin: auto;

        }

        .maxBnner {
            width: 100%;
            margin-top: 40px;
            height: auto;
            background-size: 100% 100%;

            img {
                width: 100%;
                height: auto;
                object-fit: cover;
                display: block;
            }
        }

        .scorllBanner {
            margin-top: 20px;

            .headBox {
                display: flex;
                justify-content: space-between;
                width: 100%;
                margin: auto;

                .headLeft {
                    display: flex;
                    align-items: center;

                    .line {
                        width: 26px;
                        height: 2px;
                        background: #B2B2B2;
                        border-radius: 1px;
                        margin-right: 10px;
                        cursor: pointer;
                    }

                    .activeLine {
                        background: #000000;
                    }
                }

                .rightBtn {
                    display: flex;

                    .bannerBtn {
                        width: 30px;
                        height: 30px;
                        margin-left: 10px;
                        cursor: pointer;

                        img {
                            width: 30px;
                            height: 30px;
                            display: block;
                        }
                    }

                    .bannerBtnRight {
                        transform: rotate(180deg);
                    }
                }
            }

            .bannerBox {
                overflow: hidden;
                margin-top: 30px;

                .bannerList {
                    display: flex;
                    flex-wrap: nowrap;
                    transition: all 0.3s;

                    .bannerItem {
                        margin-right: 10px;
                        width: 100%;

                        img {
                            width: 60%;
                            height: auto;
                            display: block;
                            object-fit: cover;
                        }

                        .bannerName {
                            font-weight: 500;
                            font-size: 14px;
                            color: #000000;
                            line-height: 28px;
                            margin-top: 15px;
                        }
                    }
                }
            }
        }
    }

}
</style>
